// extracted by mini-css-extract-plugin
module.exports = {"wishlist":"WishlistButton_wishlist__doFrQ","icon":"WishlistButton_icon__YFLlr"};